module.exports = __webpack_public_path__ + "static/fonts/Poppins-Medium.bf59c68.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Medium.ttf
// module id = 1030
// module chunks = 11